import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9505dac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "header pb-2 pb-sm-4",
  ref: "header"
}
const _hoisted_3 = { class: "container container--large" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ps-0" }, " Alle Maßnahmen anzeigen ", -1))
const _hoisted_5 = { class: "pt-1" }
const _hoisted_6 = { class: "d-inline" }
const _hoisted_7 = { class: "popper-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-18 flycon-info border-0 ps-1 align-top"
}, null, -1))
const _hoisted_9 = { class: "text-color--medium-emphasis" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row pt-4" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  class: "measures-body",
  ref: "tabBody"
}
const _hoisted_15 = { class: "container container--large" }
const _hoisted_16 = { class: "tab-head navi navi-tabs navi-tab-custom p-0" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "tab-link fw-medium" }
const _hoisted_19 = { class: "container container--large pt-1 pt-sm-3" }
const _hoisted_20 = { class: "row justify-content-between" }
const _hoisted_21 = { class: "col-12 col-md-8" }
const _hoisted_22 = { class: "tab-content" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Über diese Maßnahme")
const _hoisted_25 = {
  key: 5,
  class: "col-12 col-sm-4 pb-2 pb-sm-0"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title pb-1 fw-bold text-uppercase",
  innerHTML: 'Förderung'
}, null, -1))
const _hoisted_27 = { class: "custom-list--marker mb-0" }
const _hoisted_28 = {
  key: 6,
  class: "col-12 col-sm-6"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title pb-1 fw-bold text-uppercase",
  innerHTML: 'Zielfläche'
}, null, -1))
const _hoisted_30 = {
  key: 0,
  class: "mb-0 custom-list--marker"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Beschreibung")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Nutzcode")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Förderung")
const _hoisted_34 = {
  key: 0,
  class: "pb-3"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Förderhöhe'
}, null, -1))
const _hoisted_36 = {
  key: 3,
  class: "pb-3"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Greening-Faktor'
}, null, -1))
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { key: 4 }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Kombinationsmöglichkeiten")
const _hoisted_43 = {
  key: 0,
  class: "card border-0 d-flex flex-row align-items-center py-3"
}
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = {
  key: 1,
  class: "card-img bg-light d-none d-lg-flex justify-content-center align-items-center me-2"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flycon flycon-end flycon-32 flycon-photo text-color--low-emphasis" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "card-body p-0 d-flex flex-column pe-2" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Optionale Zusatzleistungen")
const _hoisted_53 = {
  key: 0,
  class: "card border-0 d-flex flex-row align-items-center py-3"
}
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = {
  key: 1,
  class: "card-img bg-light d-none d-lg-flex justify-content-center align-items-center me-2"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flycon flycon-end flycon-32 flycon-photo text-color--low-emphasis" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "card-body p-0 d-flex flex-column pe-2" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Ziel und Nutzen")
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Ziel", -1))
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Ökologischer Nutzen", -1))
const _hoisted_67 = { class: "custom-list--marker mb-0 pb-0" }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Antragsvoraussetzungen")
const _hoisted_70 = /*#__PURE__*/_createTextVNode("Antragsfristen und Verpflichtungsdauer")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Bewilligungsbehörde")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Antragsstellungsverfahren ")
const _hoisted_73 = {
  key: 1,
  class: "col-12 col-sm-6 pt-3"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Abstimmung mit unterer Naturschutzbehörde'
}, null, -1))
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Anträge, Formulare und Dokumente")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Antragsstellungsprogramm/-dokumente")
const _hoisted_77 = /*#__PURE__*/_createTextVNode("Hinweise und Merkblätter zur Antragstellung")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Bereitstellung von Anträgen/Formularen")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Richtlinien")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("Ansprechpartner")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Publizitätspflicht")
const _hoisted_82 = { key: 2 }
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Kulisse")
const _hoisted_84 = {
  key: 0,
  class: "col-12 pb-3"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-2",
  innerHTML: 'Informationen zu Kulissen'
}, null, -1))
const _hoisted_86 = {
  key: 1,
  class: "col-12 col-sm-6 pb-3"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Kulisse'
}, null, -1))
const _hoisted_88 = { class: "mb-0 custom-list--marker" }
const _hoisted_89 = {
  key: 2,
  class: "col-12 col-sm-6 pb-3"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Gebietskulisse'
}, null, -1))
const _hoisted_91 = { class: "mb-0 custom-list--marker" }
const _hoisted_92 = {
  key: 3,
  class: "col-12 col-sm-6 pb-3"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Zielarten", -1))
const _hoisted_94 = { class: "mb-0 custom-list--marker" }
const _hoisted_95 = {
  key: 4,
  class: "col-12 col-sm-6 pb-3"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Ergänzende Informationen'
}, null, -1))
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = /*#__PURE__*/_createTextVNode("Lage")
const _hoisted_99 = {
  key: 0,
  class: "col-12 col-sm-6"
}
const _hoisted_100 = { class: "d-flex ms-0 align-items-center mb-1" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, " Lage der Maßnahme auf der Fläche ", -1))
const _hoisted_102 = ["innerHTML"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 ps-1"
}, null, -1))
const _hoisted_104 = { class: "mb-0 custom-list--marker pb-2 pb-sm-0" }
const _hoisted_105 = {
  key: 1,
  class: "col-12 col-sm-6"
}
const _hoisted_106 = { class: "d-flex ms-0 align-items-center mb-1" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Lagetreue", -1))
const _hoisted_108 = ["innerHTML"]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 ps-1"
}, null, -1))
const _hoisted_110 = /*#__PURE__*/_createTextVNode("Vorgegebene Maße der förderfähigen Fläche")
const _hoisted_111 = /*#__PURE__*/_createTextVNode("Geeignete Standorte")
const _hoisted_112 = { key: 3 }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Selbstbegrünung")
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Einsaat")
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Einsaat-Termine'
}, null, -1))
const _hoisted_116 = { class: "pb-3" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Saatmischung/zulässige Kulturen'
}, null, -1))
const _hoisted_118 = ["innerHTML"]
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Nicht förderfähige NC'
}, null, -1))
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Förderfähige NC'
}, null, -1))
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-2",
  innerHTML: 'Informationen zu Saatmischungen'
}, null, -1))
const _hoisted_124 = /*#__PURE__*/_createTextVNode("Hinweise zur Anlage der Maßnahme")
const _hoisted_125 = { key: 4 }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("Düngung")
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { class: "mb-1 custom-list--marker" }
const _hoisted_129 = { key: 1 }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Erläuterungen'
}, null, -1))
const _hoisted_131 = /*#__PURE__*/_createTextVNode("Pflanzenschutz")
const _hoisted_132 = { class: "mb-0 custom-list--marker" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode("Bewirtschaftungsruhe")
const _hoisted_134 = /*#__PURE__*/_createTextVNode("Bewirtschaftungsauflagen")
const _hoisted_135 = /*#__PURE__*/_createTextVNode("Optionale Pflegemaßnahmen")
const _hoisted_136 = /*#__PURE__*/_createTextVNode("Bodenbearbeitung")
const _hoisted_137 = { class: "mb-0 custom-list--marker" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode("Befahren")
const _hoisted_139 = /*#__PURE__*/_createTextVNode("Viehbesatz")
const _hoisted_140 = { class: "list-unstyled custom-list--dott mb-0" }
const _hoisted_141 = ["innerHTML"]
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 ps-1"
}, null, -1))
const _hoisted_143 = /*#__PURE__*/_createTextVNode("Mahd-Termine (Grünland)")
const _hoisted_144 = /*#__PURE__*/_createTextVNode("Beweidung")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("Umbruch zur Nachsaat oder Einsaat einer Folgekultur")
const _hoisted_146 = /*#__PURE__*/_createTextVNode("Nutzung des Aufwuchses")
const _hoisted_147 = /*#__PURE__*/_createTextVNode("Hinweise zur Maßnahmenumsetzung")
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Ausnahmeregelungen")
const _hoisted_149 = { key: 5 }
const _hoisted_150 = /*#__PURE__*/_createTextVNode("Dokumentationspflicht")
const _hoisted_151 = { class: "custom-list-circle mb-0" }
const _hoisted_152 = { class: "list-content position-relative" }
const _hoisted_153 = { class: "d-flex flex-row align-items-center" }
const _hoisted_154 = ["innerHTML"]
const _hoisted_155 = {
  key: 0,
  class: "mb-0 pt-1"
}
const _hoisted_156 = { class: "ps-1 fs-5 text-color--medium-emphasis" }
const _hoisted_157 = { class: "d-inline-flex pt-2 align-items-center" }
const _hoisted_158 = ["data-bs-target"]
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "return-link flycon flycon-18 flycon-start flycon-chevron-right lh-0" }, "­", -1))
const _hoisted_160 = { class: "modal-header align-items-center p-3" }
const _hoisted_161 = { class: "d-flex flex-column align-items-start fs-2 fw-medium text-start" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Dokumentation")
], -1))
const _hoisted_163 = { class: "text-primary" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  class: "flycon flycon-top flycon-24 flycon-close text-dark bg-transparent lh-0 rounded-circle p-1 border-0 end-0 top-0 position-absolute me-1 mt-1"
}, null, -1))
const _hoisted_165 = { class: "modal-body p-3 modal-lg text-start" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-color--high-emphasis" }, " Termin ", -1))
const _hoisted_167 = { class: "text-color--medium-emphasis mb-0 pt-1" }
const _hoisted_168 = { class: "text-color--low-emphasis fw-normal mb-0 d-flex flex-column" }
const _hoisted_169 = { key: 0 }
const _hoisted_170 = { key: 1 }
const _hoisted_171 = { class: "pt-3" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-color--high-emphasis" }, " Aufgaben ", -1))
const _hoisted_173 = {
  key: 0,
  class: "mb-0 pt-1"
}
const _hoisted_174 = { class: "ps-1 fs-5 text-color--medium-emphasis" }
const _hoisted_175 = {
  key: 1,
  class: "text-color--medium-emphasis"
}
const _hoisted_176 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-color--high-emphasis" }, " Dokumentationsgegenstand ", -1))
const _hoisted_178 = { class: "text-color--medium-emphasis mb-0 pt-1" }
const _hoisted_179 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-color--high-emphasis" }, " Ergänzung ", -1))
const _hoisted_181 = ["innerHTML"]
const _hoisted_182 = { key: 6 }
const _hoisted_183 = /*#__PURE__*/_createTextVNode("Weitere Informationen")
const _hoisted_184 = { class: "card border-0 d-flex flex-row align-items-center" }
const _hoisted_185 = ["innerHTML"]
const _hoisted_186 = /*#__PURE__*/_createTextVNode("Begleitdokumente")
const _hoisted_187 = { class: "card border-0 d-flex flex-row align-items-center" }
const _hoisted_188 = ["innerHTML"]
const _hoisted_189 = /*#__PURE__*/_createTextVNode("Ansprechpartner")
const _hoisted_190 = { class: "card border-0 d-flex flex-row align-items-center" }
const _hoisted_191 = ["innerHTML"]
const _hoisted_192 = /*#__PURE__*/_createTextVNode("Beratungsangebote")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestSystemContainer = _resolveComponent("TestSystemContainer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_CardTextSnippet = _resolveComponent("CardTextSnippet")!
  const _component_CardBorderedBody = _resolveComponent("CardBorderedBody")!
  const _component_CardBordered = _resolveComponent("CardBordered")!
  const _component_HtmlContentContainer = _resolveComponent("HtmlContentContainer")!
  const _component_TextSnippet = _resolveComponent("TextSnippet")!
  const _component_ResourcesContainer = _resolveComponent("ResourcesContainer")!
  const _component_DateRangeDescriptionSnippet = _resolveComponent("DateRangeDescriptionSnippet")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_CardFloating = _resolveComponent("CardFloating")!

  return (_ctx.measure)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_TestSystemContainer),
            _createVNode(_component_router_link, {
              class: "return-link flycon flycon-24 flycon-start flycon-chevron-left text-orchid pb-1",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.measure.label), 1),
              (_ctx.measure.additionalService)
                ? (_openBlock(), _createBlock(_component_Popper, {
                    key: 0,
                    hover: "",
                    arrow: "",
                    "append-to-body": "true",
                    placement: "top",
                    class: "border-0 m-0 popper-wrapper position-relative align-top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, " Zugeordnete Grundmaßnahme: " + _toDisplayString(_ctx.measure.additionalServiceLabel), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_ctx.measure.measureType.label), 1),
              (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.code))
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " | " + _toDisplayString(_ctx.measure.code), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "header-img rounded-3 bg-light",
                  style: _normalizeStyle(_ctx.bgImage(_ctx.measure.titleImage)),
                  role: "img",
                  "aria-label": _ctx.measure.label
                }, null, 12, _hoisted_13)
              ])
            ])
          ])
        ], 512),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-wrapper bg-white position-sticky mb-2 mb-sm-4", { 'tab-wrapper--shadow': _ctx.tabShadow }]),
            ref: "tabWrapper"
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    onClick: ($event: any) => {;(_ctx.selectedTab = index), _ctx.scrollToTop()},
                    class: _normalizeClass({ active: index == _ctx.selectedTab })
                  }, [
                    _createElementVNode("a", _hoisted_18, _toDisplayString(tab), 1)
                  ], 10, _hoisted_17))
                }), 128))
              ])
            ])
          ], 2),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.selectedTab == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_CardBordered, null, {
                          body: _withCtx(() => [
                            _createVNode(_component_CardBorderedBody, null, {
                              heading: _withCtx(() => [
                                _hoisted_24
                              ]),
                              gridContent: _withCtx(() => [
                                (_ctx.measure.federalState.label !== '')
                                  ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                      key: 0,
                                      hasClass: "col-12 col-sm-4 pb-3",
                                      heading: 'Bundesland',
                                      content: _ctx.measure.federalState.label
                                    }, null, 8, ["content"]))
                                  : _createCommentVNode("", true),
                                (_ctx.measure.supportProgramm.label !== '')
                                  ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                      key: 1,
                                      hasClass: "col-12 col-sm-4 pb-3",
                                      heading: 'Förderprogramm',
                                      content: _ctx.measure.supportProgramm.label
                                    }, null, 8, ["content"]))
                                  : _createCommentVNode("", true),
                                (
                            _ctx.measure.validityPeriodRange.validityPeriodStart ||
                            _ctx.measure.validityPeriodRange.validityPeriodEnd !== ''
                          )
                                  ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                      key: 2,
                                      hasClass: "col-12 col-sm-4 pb-3",
                                      heading: 'Förderperiode',
                                      content: 
                            _ctx.measure.validityPeriodRange.validityPeriodStart +
                            ' - ' +
                            _ctx.measure.validityPeriodRange.validityPeriodEnd
                          
                                    }, null, 8, ["content"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_CardTextSnippet, {
                                  hasClass: "col-12 col-sm-4 pb-3",
                                  heading: 'Verpflichtungsdauer',
                                  content: 
                            _ctx.durationFormatter.format(
                              _ctx.measure.commitmentTime.value,
                              'Jahre'
                            ) || _ctx.getPlaceholder()
                          ,
                                  tooltip: _ctx.measure.commitmentTimeAdditionalInfo,
                                  tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                }, null, 8, ["content", "tooltip"]),
                                (_ctx.measure.location.length > 0)
                                  ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                      key: 3,
                                      hasClass: "col-12 col-sm-4 pb-3",
                                      heading: 'Lage',
                                      content: 
                            _ctx.arrayFormatter.format(_ctx.measure.location, '<br>')
                          
                                    }, null, 8, ["content"]))
                                  : _createCommentVNode("", true),
                                (_ctx.measure.form.length > 0)
                                  ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                      key: 4,
                                      hasClass: "col-12 col-sm-4 pb-3",
                                      heading: 'Form',
                                      content: _ctx.arrayFormatter.format(_ctx.measure.form, '<br>')
                                    }, null, 8, ["content"]))
                                  : _createCommentVNode("", true),
                                (_ctx.measure.measureBonus.length !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _hoisted_26,
                                      _createElementVNode("ul", _hoisted_27, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.measureBonus, (item, index) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            class: "fw-normal mb-0 fs-4",
                                            key: index
                                          }, _toDisplayString(_ctx.getMeasureBonusItemOutput(item, true)), 1))
                                        }), 128))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.measure.targetArea.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _hoisted_29,
                                      (_ctx.measure.targetArea.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.targetArea, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "ms-2"
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.description))
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_31
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.description,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.measureCode))
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 1 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_32
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.measureCode
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.measureBonus.length ||
                    _ctx.measure.minimumAmount !== 0 ||
                    _ctx.measure.maximumAmount !== 0 ||
                    _ctx.measure.greening.length ||
                    _ctx.measure.greeningReduction.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 2 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_33
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    (_ctx.measure.measureBonus.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _hoisted_35,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.measureBonus, (item, index) => {
                                            return (_openBlock(), _createElementBlock("p", {
                                              key: index,
                                              class: "mb-1"
                                            }, _toDisplayString(_ctx.getMeasureBonusItemOutput(item)), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.minimumAmount !== 0)
                                      ? (_openBlock(), _createBlock(_component_TextSnippet, {
                                          key: 1,
                                          heading: "Bagatellgrenze / Mindestförderung (€)",
                                          content: 
                            _ctx.currencyFormatter.format(_ctx.measure.minimumAmount)
                          
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.maximumAmount !== 0)
                                      ? (_openBlock(), _createBlock(_component_TextSnippet, {
                                          key: 2,
                                          heading: "Höchstgrenze",
                                          content: _ctx.measure.maximumAmount
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.greening.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                          _hoisted_37,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.greening, (item, index) => {
                                            return (_openBlock(), _createElementBlock("p", {
                                              key: index,
                                              innerHTML: 
                              _ctx.booleanFormatter.format(item.greeningAllowed) +
                              ' | ' +
                              item.greeningFactor +
                              ' | ' +
                              item.greeningFactorDescription
                            ,
                                              class: "mb-1 d-inline custom-inline--content"
                                            }, null, 8, _hoisted_38))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.greeningReduction.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          _createElementVNode("h3", {
                                            class: "mb-1",
                                            innerHTML: 
                              'Reduzierung der Förderung bei gleichzeitiger Beantragung als ÖVF (€/ha)'
                            
                                          }, null, 8, _hoisted_40),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.greeningReduction, (item, index) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: index,
                                              innerHTML: 
                              _ctx.currencyFormatter.format(
                                item.greeningReduction,
                                '€/ha'
                              ) +
                              ' | ' +
                              item.greeningReductionDescription
                            ,
                                              class: "custom-inline--content"
                                            }, null, 8, _hoisted_41))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.combinables.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 3 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_42
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.combinables, (item, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "px-2"
                                              }, [
                                                (
                                      (item.measure.label &&
                                        item.measure.label !== '-') ||
                                      item.type.label
                                    )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                      (item.measure.titleImage)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: item.measure.titleImage,
                                                            alt: 
                                        _ctx.getShortMesaureLabel(item.measure.label)
                                      ,
                                                            class: "me-2"
                                                          }, null, 8, _hoisted_44))
                                                        : _createCommentVNode("", true),
                                                      (!item.measure.titleImage)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_47))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_48, [
                                                        (
                                          item.measure.label &&
                                          item.measure.label !== '-'
                                        )
                                                          ? (_openBlock(), _createElementBlock("h4", {
                                                              key: 0,
                                                              class: "card-title fw-bold",
                                                              innerHTML: item.measure.label
                                                            }, null, 8, _hoisted_49))
                                                          : _createCommentVNode("", true),
                                                        (item.type.label)
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 1,
                                                              class: "text-color--medium-emphasis",
                                                              innerHTML: item.type.label
                                                            }, null, 8, _hoisted_50))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _createElementVNode("a", {
                                                        class: "card-link link-dark stretched-link flycon flycon-end flycon-24 flycon-arrow-up-right",
                                                        href: "#",
                                                        onClick: _withModifiers(($event: any) => (
                                        _ctx.navigateTo(
                                          item.measure.id,
                                          item.measure.label
                                        )
                                      ), ["prevent"])
                                                      }, null, 8, _hoisted_51)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.optionalAdditionalServices.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 4 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_52
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.optionalAdditionalServices, (item, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "px-2"
                                              }, [
                                                (
                                      (item.measure.label &&
                                        item.measure.label !== '-') ||
                                      item.type.label
                                    )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                      (item.measure.titleImage)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: item.measure.titleImage,
                                                            alt: 
                                        _ctx.getShortMesaureLabel(item.measure.label)
                                      ,
                                                            class: "me-2"
                                                          }, null, 8, _hoisted_54))
                                                        : _createCommentVNode("", true),
                                                      (!item.measure.titleImage)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _hoisted_57))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_58, [
                                                        (
                                          item.measure.label &&
                                          item.measure.label !== '-'
                                        )
                                                          ? (_openBlock(), _createElementBlock("h4", {
                                                              key: 0,
                                                              class: "card-title fw-bold",
                                                              innerHTML: item.measure.label
                                                            }, null, 8, _hoisted_59))
                                                          : _createCommentVNode("", true),
                                                        (item.type.label)
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 1,
                                                              class: "text-color--medium-emphasis",
                                                              innerHTML: item.type.label
                                                            }, null, 8, _hoisted_60))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _createElementVNode("a", {
                                                        class: "card-link link-dark stretched-link flycon flycon-end flycon-24 flycon-arrow-up-right",
                                                        href: "#",
                                                        onClick: _withModifiers(($event: any) => (
                                        _ctx.navigateTo(
                                          item.measure.id,
                                          item.measure.label
                                        )
                                      ), ["prevent"])
                                                      }, null, 8, _hoisted_61)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.target.length || _ctx.measure.ecologicalBenefit.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 5 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_62
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    (_ctx.measure.target.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                          _hoisted_64,
                                          _createElementVNode("ul", {
                                            class: _normalizeClass(["custom-list--marker pb-3 mb-0", {
                              'pb-0 mb-n4':
                                _ctx.measure.ecologicalBenefit.length === 0,
                            }])
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.target, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                class: "fw-normal mb-0 fs-4",
                                                key: index
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ], 2)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.ecologicalBenefit.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                          _hoisted_66,
                                          _createElementVNode("ul", _hoisted_67, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.ecologicalBenefit, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                class: "fw-normal mb-0 fs-4",
                                                key: index
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTab == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.eligibilityCriteria
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_69
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.eligibilityCriteria,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.supportProgramm.applicationTimeStartBase ||
                    _ctx.measure.supportProgramm.applicationTimeEndBase ||
                    _ctx.measure.supportProgramm.applicationTimeStartPayout ||
                    _ctx.measure.supportProgramm.applicationTimeEndPayout ||
                    _ctx.measure.commitmentTime.value ||
                    _ctx.measure.supportProgramm.applicationTimeStartFollowup ||
                    _ctx.measure.supportProgramm.applicationTimeEndFollowup
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 1 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_70
                                  ]),
                                  gridContent: _withCtx(() => [
                                    (
                            _ctx.dateFormatter.getDateRangeFormatted(
                              _ctx.measure.supportProgramm.applicationTimeStartBase,
                              _ctx.measure.supportProgramm.applicationTimeEndBase
                            ) !== ('–' || '')
                          )
                                      ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                          key: 0,
                                          hasClass: "col-12 col-sm-4 pb-2 pb-md-0",
                                          heading: 'Grundantrag',
                                          content: 
                            _ctx.dateFormatter.getDateRangeFormatted(
                              _ctx.measure.supportProgramm.applicationTimeStartBase,
                              _ctx.measure.supportProgramm.applicationTimeEndBase
                            )
                          ,
                                          tooltip: 'Antragszeitraum gilt ab 1 Jahr vor Maßnahmenbeginn',
                                          tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true),
                                    (
                            _ctx.dateFormatter.getDateRangeFormatted(
                              _ctx.measure.supportProgramm
                                .applicationTimeStartPayout,
                              _ctx.measure.supportProgramm.applicationTimeEndPayout
                            ) !== ('–' || '')
                          )
                                      ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                          key: 1,
                                          hasClass: "col-12 col-sm-4 pb-2 pb-md-0",
                                          heading: 'Auszahlungsantrag',
                                          content: 
                            _ctx.dateFormatter.getDateRangeFormatted(
                              _ctx.measure.supportProgramm
                                .applicationTimeStartPayout,
                              _ctx.measure.supportProgramm.applicationTimeEndPayout
                            )
                          ,
                                          tooltip: 'Auszahlungsantrag gilt während Laufzeit',
                                          tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_CardTextSnippet, {
                                      hasClass: "col-12 col-sm-4 pb-2 pb-md-4",
                                      heading: 'Verpflichtungsdauer',
                                      content: 
                            _ctx.durationFormatter.format(
                              _ctx.measure.commitmentTime.value,
                              'Jahre'
                            ) || _ctx.getPlaceholder()
                          ,
                                      tooltip: _ctx.measure.commitmentTimeAdditionalInfo,
                                      tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                    }, null, 8, ["content", "tooltip"]),
                                    (
                            _ctx.dateFormatter.getDateRangeFormatted(
                              _ctx.measure.supportProgramm
                                .applicationTimeStartFollowup,
                              _ctx.measure.supportProgramm.applicationTimeEndFollowup
                            ) !== '–'
                          )
                                      ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                          key: 2,
                                          hasClass: "col-12 col-sm-4",
                                          heading: 'Folgeantrag',
                                          content: 
                            _ctx.dateFormatter.getDateRangeFormatted(
                              _ctx.measure.supportProgramm
                                .applicationTimeStartFollowup,
                              _ctx.measure.supportProgramm.applicationTimeEndFollowup
                            )
                          
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.supportProgramm.grantingAuthority)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 2 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_71
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": 
                            _ctx.measure.supportProgramm.grantingAuthority
                          
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.supportProgramm.applicationProcess ||
                    _ctx.measure.supportProgramm.authorityCoordination
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 3 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_72
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    (_ctx.measure.supportProgramm.applicationProcess)
                                      ? (_openBlock(), _createBlock(_component_HtmlContentContainer, {
                                          key: 0,
                                          "html-content": 
                            _ctx.measure.supportProgramm.applicationProcess
                          ,
                                          wrapperClass: 'custom-list--marker'
                                        }, null, 8, ["html-content"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.supportProgramm.authorityCoordination)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                          _hoisted_74,
                                          _createVNode(_component_HtmlContentContainer, {
                                            "html-content": 
                              _ctx.booleanFormatter.format(
                                _ctx.measure.supportProgramm.authorityCoordination
                              )
                            
                                          }, null, 8, ["html-content"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.supportProgramm.applicationDeploymentSource.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 4 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_75
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            _createVNode(_component_ResourcesContainer, {
                                              list: 
                                    _ctx.measure.supportProgramm
                                      .applicationDeploymentSource
                                  ,
                                              wrapperClass: 'px-2'
                                            }, null, 8, ["list"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.supportProgramm.applicationProgramResource.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 5 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_76
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            _createVNode(_component_ResourcesContainer, {
                                              list: 
                                    _ctx.measure.supportProgramm
                                      .applicationProgramResource
                                  ,
                                              wrapperClass: 'px-2'
                                            }, null, 8, ["list"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.supportProgramm.informationSheetSource.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 6 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_77
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            _createVNode(_component_ResourcesContainer, {
                                              list: 
                                    _ctx.measure.supportProgramm
                                      .informationSheetSource
                                  ,
                                              wrapperClass: 'px-2'
                                            }, null, 8, ["list"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.supportProgramm.applicationProgramResource.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 7 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_78
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            _createVNode(_component_ResourcesContainer, {
                                              list: 
                                    _ctx.measure.supportProgramm
                                      .applicationProgramResource
                                  ,
                                              urlList: true,
                                              wrapperClass: 'px-2'
                                            }, null, 8, ["list"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.supportProgramm.directiveResource.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 8 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_79
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                      body: _withCtx(() => [
                                        _createVNode(_component_CardBorderedBody, null, {
                                          defaultContent: _withCtx(() => [
                                            _createVNode(_component_ResourcesContainer, {
                                              list: 
                                    _ctx.measure.supportProgramm.directiveResource
                                  ,
                                              wrapperClass: 'px-2'
                                            }, null, 8, ["list"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.supportProgramm.contact)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 9 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_80
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.supportProgramm.contact
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.supportProgramm.disclosureObligation ||
                    _ctx.measure.supportProgramm.disclosureObligationAdditionalInfo
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 10 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_81
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    (
                            _ctx.stringHelper.isHtmlStringNotEmpty(
                              _ctx.measure.supportProgramm.disclosureObligation
                            )
                          )
                                      ? (_openBlock(), _createBlock(_component_HtmlContentContainer, {
                                          key: 0,
                                          "html-content": 
                            _ctx.booleanFormatter.format(
                              _ctx.measure.supportProgramm.disclosureObligation
                            )
                          ,
                                          wrapperClass: 'pb-1'
                                        }, null, 8, ["html-content"]))
                                      : _createCommentVNode("", true),
                                    (
                            _ctx.measure.supportProgramm
                              .disclosureObligationAdditionalInfo
                          )
                                      ? (_openBlock(), _createBlock(_component_HtmlContentContainer, {
                                          key: 1,
                                          "html-content": 
                            _ctx.measure.supportProgramm
                              .disclosureObligationAdditionalInfo
                          ,
                                          wrapperClass: 'pt-1'
                                        }, null, 8, ["html-content"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTab == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        (
                    _ctx.measure.supportProgramm.sceneryInfoSource.length ||
                    _ctx.measure.scenery.length ||
                    _ctx.measure.scenerySpartial.length ||
                    _ctx.measure.sceneryTargetSpecies.length ||
                    _ctx.measure.targetArea.length ||
                    _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.sceneryInfo) ||
                    _ctx.measure.targetArea.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_83
                                  ]),
                                  gridContent: _withCtx(() => [
                                    (
                            _ctx.measure.supportProgramm.sceneryInfoSource.length
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                          _hoisted_85,
                                          _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                            body: _withCtx(() => [
                                              _createVNode(_component_CardBorderedBody, null, {
                                                defaultContent: _withCtx(() => [
                                                  _createVNode(_component_ResourcesContainer, {
                                                    list: 
                                      _ctx.measure.supportProgramm.sceneryInfoSource
                                    ,
                                                    wrapperClass: 'px-2'
                                                  }, null, 8, ["list"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.scenery.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                          _hoisted_87,
                                          _createElementVNode("ul", _hoisted_88, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.scenery, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "ms-2"
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.scenerySpartial.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                          _hoisted_90,
                                          _createElementVNode("ul", _hoisted_91, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.scenerySpartial, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "ms-2"
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.sceneryTargetSpecies.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                          _hoisted_93,
                                          _createElementVNode("ul", _hoisted_94, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.sceneryTargetSpecies, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "ms-2"
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (
                            _ctx.stringHelper.isHtmlStringNotEmpty(
                              _ctx.measure.sceneryInfo
                            )
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                          _hoisted_96,
                                          _createElementVNode("p", {
                                            innerHTML: _ctx.measure.sceneryInfo,
                                            class: "mb-0"
                                          }, null, 8, _hoisted_97)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.fixedAreaInfo) ||
                    _ctx.measure.fixedArea.label
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 1 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_98
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    (
                            _ctx.stringHelper.isHtmlStringNotEmpty(
                              _ctx.measure.fixedAreaInfo
                            )
                          )
                                      ? (_openBlock(), _createBlock(_component_HtmlContentContainer, {
                                          key: 0,
                                          "html-content": _ctx.measure.fixedAreaInfo,
                                          wrapperClass: 'pb-3 custom-list--marker'
                                        }, null, 8, ["html-content"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  gridContent: _withCtx(() => [
                                    (_ctx.measure.location.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                          _createElementVNode("div", _hoisted_100, [
                                            _hoisted_101,
                                            (_ctx.measure.locationInfo)
                                              ? (_openBlock(), _createBlock(_component_Popper, {
                                                  key: 0,
                                                  hover: "",
                                                  arrow: "",
                                                  "append-to-body": "true",
                                                  placement: "top",
                                                  class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block"
                                                }, {
                                                  content: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                      class: "popper-content",
                                                      innerHTML: _ctx.measure.locationInfo
                                                    }, null, 8, _hoisted_102)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _hoisted_103
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("ul", _hoisted_104, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.location, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "ms-2"
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.measure.fixedArea.label)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                          _createElementVNode("div", _hoisted_106, [
                                            _hoisted_107,
                                            (_ctx.measure.fixedAreaInfo)
                                              ? (_openBlock(), _createBlock(_component_Popper, {
                                                  key: 0,
                                                  hover: "",
                                                  arrow: "",
                                                  "append-to-body": "true",
                                                  placement: "top",
                                                  class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block"
                                                }, {
                                                  content: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                      class: "popper-content",
                                                      innerHTML: _ctx.measure.fixedAreaInfo
                                                    }, null, 8, _hoisted_108)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _hoisted_109
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createVNode(_component_TextSnippet, {
                                            content: 
                              _ctx.measure.fixedArea.label || _ctx.getPlaceholder()
                            ,
                                            spacing: 'pb-0'
                                          }, null, 8, ["content"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.sizeInformation
                    ) ||
                    _ctx.measure.widthMin !== 0 ||
                    _ctx.measure.widthMax !== 0 ||
                    _ctx.measure.hectareMin !== 0 ||
                    _ctx.measure.hectareMax !== 0
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 2 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_110
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    (
                            _ctx.stringHelper.isHtmlStringNotEmpty(
                              _ctx.measure.sizeInformation
                            )
                          )
                                      ? (_openBlock(), _createBlock(_component_HtmlContentContainer, {
                                          key: 0,
                                          "html-content": _ctx.measure.sizeInformation,
                                          class: _normalizeClass(
                            _ctx.measure.widthMin !== 0 ||
                            _ctx.measure.widthMax !== 0 ||
                            _ctx.measure.hectareMin !== 0 ||
                            _ctx.measure.hectareMax !== 0
                              ? 'pb-3'
                              : ''
                          ),
                                          wrapperClass: 'custom-list--marker'
                                        }, null, 8, ["html-content", "class"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  gridContent: _withCtx(() => [
                                    (
                            _ctx.measure.widthMin !== 0 || _ctx.measure.widthMax !== 0
                          )
                                      ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                          key: 0,
                                          hasClass: "col-12 col-sm-4",
                                          heading: "Breite",
                                          content: 
                            _ctx.areaUnitFormatter.formatRange(
                              { from: _ctx.measure.widthMin, to: _ctx.measure.widthMax },
                              'm'
                            )
                          
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true),
                                    (
                            _ctx.measure.hectareMin !== 0 || _ctx.measure.hectareMax !== 0
                          )
                                      ? (_openBlock(), _createBlock(_component_CardTextSnippet, {
                                          key: 1,
                                          hasClass: "col-12 col-sm-4",
                                          heading: "Fläche",
                                          content: 
                            _ctx.areaUnitFormatter.formatRange(
                              {
                                from: _ctx.measure.hectareMin,
                                to: _ctx.measure.hectareMax,
                              },
                              'ha'
                            )
                          
                                        }, null, 8, ["content"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.locationRecommendation
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 3 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_111
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.locationRecommendation,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTab == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        (_ctx.measure.selfGreening)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_113
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": 
                            _ctx.booleanFormatter.format(_ctx.measure.selfGreening)
                          
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.sowings.length ||
                    _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.seedMix) ||
                    _ctx.measure.seedMixResource.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 1 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, _createSlots({
                                  heading: _withCtx(() => [
                                    _hoisted_114
                                  ]),
                                  _: 2
                                }, [
                                  (_ctx.measure.sowings.length)
                                    ? {
                                        name: "defaultContent",
                                        fn: _withCtx(() => [
                                          _hoisted_115,
                                          _createElementVNode("div", _hoisted_116, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.sowings, (item, index) => {
                                              return (_openBlock(), _createBlock(_component_TextSnippet, {
                                                class: "card-body-bg-light rounded-1 p-2",
                                                dateFrom: item.from,
                                                dateUntil: item.until,
                                                dateFromDescription: item.from_description,
                                                dateUntilDescription: item.until_description,
                                                dateInterval: 
                              item.interval ? item.interval.value : ''
                            ,
                                                content: item.description,
                                                key: index,
                                                spacing: 'pb-2',
                                                tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                              }, null, 8, ["dateFrom", "dateUntil", "dateFromDescription", "dateUntilDescription", "dateInterval", "content"]))
                                            }), 128))
                                          ])
                                        ])
                                      }
                                    : undefined
                                ]), 1024),
                                _createVNode(_component_CardBorderedBody, null, _createSlots({ _: 2 }, [
                                  (
                          _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.seedMix)
                        )
                                    ? {
                                        name: "defaultContent",
                                        fn: _withCtx(() => [
                                          _hoisted_117,
                                          _createElementVNode("div", {
                                            innerHTML: _ctx.measure.seedMix,
                                            class: "card-body p-0 pb-1 custom-list--marker"
                                          }, null, 8, _hoisted_118)
                                        ])
                                      }
                                    : undefined
                                ]), 1024),
                                _createVNode(_component_CardBorderedBody, null, _createSlots({ _: 2 }, [
                                  (
                          _ctx.stringHelper.isHtmlStringNotEmpty(
                            _ctx.measure.seedMix_none_nc
                          )
                        )
                                    ? {
                                        name: "defaultContent",
                                        fn: _withCtx(() => [
                                          _hoisted_119,
                                          _createElementVNode("div", {
                                            innerHTML: _ctx.measure.seedMix_none_nc,
                                            class: "card-body p-0 pb-1 custom-list--marker"
                                          }, null, 8, _hoisted_120)
                                        ])
                                      }
                                    : undefined
                                ]), 1024),
                                _createVNode(_component_CardBorderedBody, null, _createSlots({ _: 2 }, [
                                  (
                          _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.seedMix_nc)
                        )
                                    ? {
                                        name: "defaultContent",
                                        fn: _withCtx(() => [
                                          _hoisted_121,
                                          _createElementVNode("div", {
                                            innerHTML: _ctx.measure.seedMix_nc,
                                            class: "card-body p-0 pb-1 custom-list--marker"
                                          }, null, 8, _hoisted_122)
                                        ])
                                      }
                                    : undefined
                                ]), 1024),
                                _createVNode(_component_CardBorderedBody, null, _createSlots({ _: 2 }, [
                                  (_ctx.measure.seedMixResource.length)
                                    ? {
                                        name: "defaultContent",
                                        fn: _withCtx(() => [
                                          _hoisted_123,
                                          _createVNode(_component_CardBordered, { wrapperClass: 'resource-wrapper' }, {
                                            body: _withCtx(() => [
                                              _createVNode(_component_CardBorderedBody, null, {
                                                defaultContent: _withCtx(() => [
                                                  _createVNode(_component_ResourcesContainer, {
                                                    list: _ctx.measure.seedMixResource,
                                                    wrapperClass: 'px-2'
                                                  }, null, 8, ["list"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      }
                                    : undefined
                                ]), 1024)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.noteMeasureConception
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 2 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_124
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.noteMeasureConception,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTab == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                        (
                    _ctx.measure.fertilizationTypeOfRestriction.length ||
                    _ctx.measure.fertilizationType.length
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_126
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    (_ctx.measure.fertilizationType.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                          _createElementVNode("ul", _hoisted_128, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.fertilizationType, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "ms-2"
                                              }, _toDisplayString(item.label), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (
                            _ctx.stringHelper.isHtmlStringNotEmpty(
                              _ctx.measure.fertilizationInfo
                            )
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                          _hoisted_130,
                                          _createVNode(_component_TextSnippet, {
                                            content: _ctx.measure.fertilizationInfo,
                                            spacing: ''
                                          }, null, 8, ["content"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.pesticidesUsage.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 1 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_131
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_132, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.pesticidesUsage, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: index,
                                          class: "ms-2"
                                        }, _toDisplayString(item.label), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.measure.managementRest.from || _ctx.measure.managementRest.until
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 2 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_133
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    _createVNode(_component_TextSnippet, {
                                      class: "card-body-bg-light rounded-1 p-2",
                                      dateFrom: _ctx.measure.managementRest.from,
                                      dateUntil: _ctx.measure.managementRest.until,
                                      dateFromDescription: 
                            _ctx.measure.managementRest.from_description
                          ,
                                      dateUntilDescription: 
                            _ctx.measure.managementRest.until_description
                          ,
                                      dateInterval: 
                            _ctx.measure.managementRest.interval
                              ? _ctx.measure.managementRest.interval.value
                              : ''
                          ,
                                      content: _ctx.measure.managementRest.description,
                                      spacing: 'pb-2',
                                      tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                    }, null, 8, ["dateFrom", "dateUntil", "dateFromDescription", "dateUntilDescription", "dateInterval", "content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.maintenanceRequirements
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 3 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_134
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.maintenanceRequirements,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.maintenanceMeasures
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 4 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_135
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.maintenanceMeasures
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.tillage.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 5 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_136
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_137, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.tillage, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: index,
                                          class: "ms-2"
                                        }, _toDisplayString(item.label), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.driveOn.label)
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 6 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_138
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.driveOn.label
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.livestock.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 7 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_139
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_140, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.livestock, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: index,
                                          class: "ms-0 align-items-center",
                                          style: {"display":"flex !important"}
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.getLivestockOutput(item)), 1),
                                          (item.description)
                                            ? (_openBlock(), _createBlock(_component_Popper, {
                                                key: 0,
                                                hover: "",
                                                arrow: "",
                                                "append-to-body": "true",
                                                placement: "top",
                                                class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block"
                                              }, {
                                                content: _withCtx(() => [
                                                  _createElementVNode("div", {
                                                    class: "popper-content",
                                                    innerHTML: item.description
                                                  }, null, 8, _hoisted_141)
                                                ]),
                                                default: _withCtx(() => [
                                                  _hoisted_142
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.mahdDates.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 8 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_143
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.mahdDates, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_TextSnippet, {
                                        class: "card-body-bg-light rounded-1 p-2",
                                        dateFrom: item.from,
                                        dateUntil: item.until,
                                        dateFromDescription: item.from_description,
                                        dateUntilDescription: item.until_description,
                                        dateInterval: 
                            item.interval ? item.interval.value : ''
                          ,
                                        content: item.description,
                                        key: index,
                                        spacing: 'pb-2',
                                        tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                      }, null, 8, ["dateFrom", "dateUntil", "dateFromDescription", "dateUntilDescription", "dateInterval", "content"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.grazing.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 9 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_144
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.grazing, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_TextSnippet, {
                                        class: "card-body-bg-light rounded-1 p-2",
                                        dateFrom: item.from,
                                        dateUntil: item.until,
                                        dateFromDescription: item.from_description,
                                        dateUntilDescription: item.until_description,
                                        dateInterval: 
                            item.interval ? item.interval.value : ''
                          ,
                                        content: item.description,
                                        key: index,
                                        spacing: 'pb-2',
                                        tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                      }, null, 8, ["dateFrom", "dateUntil", "dateFromDescription", "dateUntilDescription", "dateInterval", "content"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.soilCultivationForReseedings.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 10 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_145
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.soilCultivationForReseedings, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_TextSnippet, {
                                        class: "card-body-bg-light rounded-1 p-2",
                                        dateFrom: item.from,
                                        dateUntil: item.until,
                                        dateFromDescription: item.from_description,
                                        dateUntilDescription: item.until_description,
                                        dateInterval: 
                            item.interval ? item.interval.value : ''
                          ,
                                        content: item.description,
                                        key: index,
                                        spacing: 'pb-2',
                                        tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                      }, null, 8, ["dateFrom", "dateUntil", "dateFromDescription", "dateUntilDescription", "dateInterval", "content"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.measure.useOfVegetationDates.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 11 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_146
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.useOfVegetationDates, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_TextSnippet, {
                                        class: "card-body-bg-light rounded-1 p-2",
                                        dateFrom: item.from,
                                        dateUntil: item.until,
                                        dateFromDescription: item.from_description,
                                        dateUntilDescription: item.until_description,
                                        dateInterval: 
                            item.interval ? item.interval.value : ''
                          ,
                                        label: item.internalName,
                                        content: item.description,
                                        key: index,
                                        spacing: 'pb-2',
                                        tooltipWrapperClass: 'inline-block align-middle d-none d-md-inline-block'
                                      }, null, 8, ["dateFrom", "dateUntil", "dateFromDescription", "dateUntilDescription", "dateInterval", "label", "content"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.managementNotes)
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 12 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_147
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.managementNotes,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.exceptions))
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 13 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_148
                                  ]),
                                  htmlContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": _ctx.measure.exceptions,
                                      wrapperClass: 'custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTab == 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                        (_ctx.measure.documentation.length)
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_150
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    _createElementVNode("ol", _hoisted_151, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.documentation, (item, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "pb-3 mb-0",
                                          key: index
                                        }, [
                                          _createElementVNode("div", _hoisted_152, [
                                            _createElementVNode("div", _hoisted_153, [
                                              _createElementVNode("h4", {
                                                class: "mb-0 pe-1 fs-3",
                                                innerHTML: item.title
                                              }, null, 8, _hoisted_154)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _createVNode(_component_DateRangeDescriptionSnippet, {
                                                clazz: 'mb-0 text-color--low-emphasis',
                                                item: {
                                    id: item.date.id,
                                    from: item.date.from,
                                    until: item.date.until,
                                    description: undefined,
                                    interval: item.date.interval,
                                  }
                                              }, null, 8, ["item"])
                                            ]),
                                            (item.proofs)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.proofs, (proof, idx) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: _normalizeClass(["d-flex align-items-center", idx === 0 ? 'pt-0' : 'pt-1']),
                                                      key: idx
                                                    }, [
                                                      _createElementVNode("a", {
                                                        class: _normalizeClass(["card-link stretched-link flycon flycon-end flycon-18 link-primary", {
                                      'flycon-camera':
                                        proof.category === 'camera',
                                      'flycon-route':
                                        proof.category === 'route',
                                      'flycon-file-text':
                                        proof.category === 'file-text',
                                      'flycon-seeding':
                                        proof.category === 'seeding',
                                      'flycon-edit': proof.category === 'edit',
                                    }]),
                                                        target: "blank"
                                                      }, null, 2),
                                                      _createElementVNode("span", _hoisted_156, _toDisplayString(proof.label), 1)
                                                    ], 2))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_157, [
                                              _createElementVNode("a", {
                                                class: "custom-list-circle--link link-dark fw-medium lh-sm",
                                                type: "button",
                                                "data-bs-toggle": "modal",
                                                "data-bs-target": 
                                    '#documentationmodal-' + item.id
                                  
                                              }, "Mehr Anzeigen", 8, _hoisted_158),
                                              _hoisted_159
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measure.documentation, (item, index) => {
                          return (_openBlock(), _createBlock(_component_Modal, {
                            key: index,
                            name: 'documentationmodal-' + item.id
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_160, [
                                _createElementVNode("div", _hoisted_161, [
                                  _hoisted_162,
                                  _createElementVNode("span", _hoisted_163, _toDisplayString(item.title), 1)
                                ]),
                                _hoisted_164
                              ])
                            ]),
                            body: _withCtx(() => [
                              _createElementVNode("div", _hoisted_165, [
                                _createElementVNode("div", null, [
                                  _hoisted_166,
                                  _createElementVNode("p", _hoisted_167, [
                                    _createVNode(_component_DateRangeDescriptionSnippet, {
                                      clazz: 'mb-0',
                                      item: {
                              id: item.date.id,
                              from: item.date.from,
                              until: item.date.until,
                              description: undefined,
                              interval: item.date.interval,
                            }
                                    }, null, 8, ["item"])
                                  ]),
                                  _createElementVNode("p", _hoisted_168, [
                                    (item.from_description)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_169, _toDisplayString(item.from_description), 1))
                                      : _createCommentVNode("", true),
                                    (item.until_description)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_170, _toDisplayString(item.until_description), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_171, [
                                  _hoisted_172,
                                  (item.proofs.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.proofs, (proof, idx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["d-flex align-items-center", { 'pt-1': idx !== 0 }]),
                                            key: idx
                                          }, [
                                            _createElementVNode("a", {
                                              class: _normalizeClass(["card-link stretched-link flycon flycon-end flycon-18 link-primary", `flycon-${proof.category}`]),
                                              target: "blank"
                                            }, null, 2),
                                            _createElementVNode("span", _hoisted_174, _toDisplayString(proof.label), 1)
                                          ], 2))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(_ctx.getPlaceholder()), 1))
                                ]),
                                (item.targets.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                      _hoisted_177,
                                      _createElementVNode("ul", _hoisted_178, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.targets, (target, idx) => {
                                          return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(target.label), 1))
                                        }), 128))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.stringHelper.isHtmlStringNotEmpty(item.description)
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      _hoisted_180,
                                      _createElementVNode("div", {
                                        innerHTML: item.description,
                                        class: "text-color--medium-emphasis lh-base pt-1 space-remove--b"
                                      }, null, 8, _hoisted_181)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["name"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedTab == 6)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.additionalInformation
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 0 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_183
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_184, [
                                      _createElementVNode("div", {
                                        class: "card-body p-0 custom-list--marker",
                                        innerHTML: _ctx.measure.additionalInformation
                                      }, null, 8, _hoisted_185)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.additionalDocuments
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 1 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_186
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_187, [
                                      _createElementVNode("div", {
                                        class: "card-body p-0 custom-list--marker",
                                        innerHTML: _ctx.measure.additionalDocuments
                                      }, null, 8, _hoisted_188)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.measure.contacts))
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 2 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_189
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_190, [
                                      _createElementVNode("div", {
                                        class: "card-body p-0 custom-list--marker",
                                        innerHTML: _ctx.measure.contacts
                                      }, null, 8, _hoisted_191)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
                    _ctx.stringHelper.isHtmlStringNotEmpty(
                      _ctx.measure.supportProgramm.adviceOffers
                    )
                  )
                          ? (_openBlock(), _createBlock(_component_CardBordered, { key: 3 }, {
                              body: _withCtx(() => [
                                _createVNode(_component_CardBorderedBody, null, {
                                  heading: _withCtx(() => [
                                    _hoisted_192
                                  ]),
                                  defaultContent: _withCtx(() => [
                                    _createVNode(_component_HtmlContentContainer, {
                                      "html-content": 
                            _ctx.measure.supportProgramm.adviceOffers
                          ,
                                      wrapperClass: 'pb-1 custom-list--marker'
                                    }, null, 8, ["html-content"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_CardFloating, {
                id: _ctx.measure.id
              }, null, 8, ["id"])
            ])
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}